import { atomWithStorage } from 'jotai/utils';

export const AI_PROMPT_DISMISSALS_STORAGE_KEY = 'aiPromptDismissalsV1';

export type AiPromptSurface =
  | 'reportPromotion'
  | 'reportConfiguration'
  | 'pageSelection';

export type AiPromptDismissalMap = Record<string, true>;

export const aiPromptDismissalsAtom = atomWithStorage<AiPromptDismissalMap>(
  AI_PROMPT_DISMISSALS_STORAGE_KEY,
  {},
  undefined,
  { getOnInit: true },
);

/** Identifies one prompt for one user in one organisation. */
export function buildAiPromptKey(
  surface: AiPromptSurface,
  userId: number,
  organisationId: number,
): string {
  return `${userId}:${organisationId}:${surface}`;
}

export function normaliseAiPromptDismissals(
  value: unknown,
): AiPromptDismissalMap {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return {};

  return Object.fromEntries(
    Object.entries(value).filter(([, dismissed]) => dismissed === true),
  );
}

export function addAiPromptDismissal(
  currentValue: unknown,
  key: string,
): AiPromptDismissalMap {
  return {
    ...normaliseAiPromptDismissals(currentValue),
    [key]: true,
  };
}
